<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">

            <header>
                <h2 i18n>Unsere Referenzprojekte</h2>
            </header>

            <p i18n>Unsere Referenzprojekte zeigen, wie wir maßgeschneiderte IT-Lösungen erfolgreich umgesetzt haben – von der ersten Idee bis zum laufenden Betrieb. Jedes Projekt ist
                ein Beweis für unsere Leidenschaft für Technologie, unsere Kreativität und unsere Fähigkeit, komplexe Herausforderungen effizient zu meistern.</p>
            <p i18n>Lassen Sie sich von einigen unserer bisherigen Projekten inspirieren und sehen Sie selbst, wie wir gemeinsam mit unseren Kunden zukunftsweisende Lösungen entwickelt
                haben.
            </p>

        </div>
    </section>
</div>
<div class="wrapper pb-3">
    <section class="container">
        <div class="row features justify-content-center ">

            <!-- Projekt 1: Felis Abenteuer -->
            <div class="card mb-4 shadow-sm rounded hover-card d-flex flex-column flex-md-row align-items-center">
                <div class="card-img-wrapper flex-shrink-0 me-md-3 mb-3 mb-md-0">
                    <a href="/referenzen/Felis Abenteuer.png" target="_blank">
                        <img src="/referenzen/Felis Abenteuer.png" alt="Statische Webseite für digitalen Adventskalender" class="project-img" i18n-alt>
                    </a>
                </div>
                <div class="card-body">
                    <h3 class="card-title" i18n>Statische Webseite zur Bereitstellung eines digitalen Adventskalenders</h3>
                    <p i18n>Für <a href="https://hoeradventskalender.de" target="_blank">KP PressConsulting</a> haben wir eine statische Webseite erstellt, um einen digitalen
                        Adventskalender interaktiv und nutzerfreundlich bereitzustellen. Das Projekt umfasst ansprechendes Design, einfache Navigation und mobile Optimierung.</p>
                    <p i18n><strong>Besonderheit:</strong> Zur Monetarisierung der digitalen Inhalte wurde eine Anbindung an <a href="https://www.paypal.com" target="_blank">PayPal</a>
                        implementiert. Nutzer können direkt auf der Seite sichere Zahlungen tätigen, um exklusive Inhalte freizuschalten.</p>
                </div>
            </div>


            <section class="col-6 col-12-narrower feature text-start">
                <header class="major">
                    <h2 i18n>IT- und Netzwerklösung für ein modernes Büro</h2>
                </header>
                <div class="image-wrapper">
                    <div class="image featured">
                        <a href="https://www.vollmersimmobilien.de/" class="image featured" aria-label="Vollmers Immobilien Webseite öffnen" i18n-aria-label>
                            <img src="/referenzen/vollmers.jpg" alt="Vollmers Immobilien GmbH" i18n-alt />
                        </a>
                    </div>
                </div>

                <div class="container mb-3">
                    <div class="row align-items-center">
                        <div class="col-4">
                            <img src="/referenzen/LogoVollmers.png" alt="Vollmers Immobilien GmbH" class="img-fluid" i18n-alt>
                        </div>
                        <div class="col-8">
                            <p class="mb-0" i18n>
                                Die Vollmers Immobilien GmbH stand vor der Aufgabe, ein stabiles und schnelles Netzwerk für die Bürokommunikation und Datenverwaltung zu
                                realisieren. Dabei lag der Fokus auf einer zentralen Verwaltung, hoher Ausfallsicherheit und skalierbaren Komponenten für zukünftige Erweiterungen.
                            </p>
                        </div>
                    </div>
                </div>

                <strong><u i18n>Unsere Lösung:</u></strong><br><br>

                <strong i18n>Netzwerk-Infrastruktur:</strong>
                <ul>
                    <li i18n>Verlegung von <strong>100 m Cat7-Duplex-Kabel</strong> für eine stabile und leistungsstarke Verbindung.</li>
                    <li i18n>Einsatz von <strong>METZ CONNECT C6Amodulen</strong> und Access Points für zuverlässige Netzwerkanbindungen.</li>
                    <li i18n>Konfiguration eines Unifi Switch und mehrerer AccessPoints, um ein flächendeckendes WLAN mit optimaler Geschwindigkeit zu gewährleisten.</li>
                </ul>


                <strong i18n>Arbeitsplatzanbindung:</strong>
                <ul>
                    <li i18n>Verbau von <strong>Brüstungskanälen</strong> und <strong>Geräteeinbaudosen</strong>, um eine saubere und benutzerfreundliche Verkabelung zu
                        ermöglichen.</li>
                    <li i18n>Bereitstellung von <strong>Digitus Patchkabeln</strong> in verschiedenen Längen für maximale Flexibilität.</li>
                </ul>

                <strong i18n>Kommunikationssystem:</strong>
                <ul>
                    <li i18n>Einrichtung moderner Yealink IP-Telefone für eine zuverlässige und intuitive Bürokommunikation.</li>
                </ul>

                <strong i18n>Server- und Speicherlösung:</strong>
                <ul>
                    <li i18n>Installation eines <strong>Qnap NAS</strong> inkl. Upgrade KIT mit <strong>WD Red Pro Festplatten</strong> für eine zentrale und gesicherte
                        Datenspeicherung.</li>
                </ul>

                <strong i18n>Rechenpower und Ausfallsicherheit:</strong>
                <ul>
                    <li i18n>Integration eines leistungsstarken <strong>GEEKOM NUC Mini PCs</strong> mit AMD Ryzen 7 für anspruchsvolle Anwendungen.</li>
                    <li i18n>Sicherstellung der Stromversorgung mit einer USV, um Ausfälle und Datenverluste zu vermeiden.</li>
                </ul>

                <blockquote>
                    <p i18n>
                        "AlbCode hat unser Netzwerk perfekt auf unsere Bedürfnisse abgestimmt. Die professionelle Umsetzung und die durchdachte Auswahl der Komponenten haben unsere
                        Erwartungen übertroffen."
                    </p>
                    <cite i18n>- Björn Vollmers<br>Geschäftsführer der <a href="https://www.vollmersimmobilien.de/" target="_blank" rel="noopener noreferrer">Vollmers Immobilien
                            GmbH</a></cite>
                </blockquote>

            </section>

            <section class="col-6 col-12-narrower feature text-start">
                <header class="major">
                    <h2 i18n>Development of a Web-Based Veterinary Portal for Sky Ridge Compounding Pharmacy (USA)</h2>
                </header>

                <div class="image-wrapper">
                    <div class="image featured">
                        <a href="https://www.skyridgecompoundingpharmacy.com/" class="image featured" aria-label="Sky Ridge Compounding Pharmacy Webseite öffnen" i18n-aria-label>
                            <img src="/referenzen/skyridgeLogo.png" alt="Sky Ridge Compounding Pharmacy" i18n-alt />
                        </a>
                    </div>
                </div>

                <p i18n>For Sky Ridge Compounding Pharmacy in the USA, we developed a custom web-based portal that allows veterinarians to easily register, complete forms, and manage
                    documents.</p>

                <strong><u i18n>Key Features:</u></strong><br><br>
                <ul>
                    <li i18n>User registration with admin approval process for account control</li>
                    <li i18n>Automatic generation and emailing of PDF documents to the pharmacy</li>
                    <li i18n>Hosting including SSL setup, with integration into the existing website via iframe</li>
                    <li i18n>Dynamic management of product lists tailored to the pharmacy's needs</li>
                    <li i18n>Optimized layout for seamless embedding into websites via iframe</li>
                </ul>
                <p i18n>The portal was developed in close collaboration with the client and successfully deployed on a dedicated domain.</p>
                <p i18n><strong>Technologies:</strong> Java, Spring Boot, Angular, MySQL</p>

                <div class="image-wrapper">
                    <div class="image featured"><img src="/referenzen/skyridge.png" alt="Development of a Web-Based Veterinary Portal for Sky Ridge Compounding Pharmacy (USA)" i18n-alt />
                    </div>
                </div>
            </section>
        </div>
    </section>
</div>
<div class="wrapper pb-3">
    <section class="container">
        <div class="row features justify-content-center ">
            <section class="col-6 col-12-narrower feature text-start">
                <header class="major">
                    <h2 i18n>Webportal für die PZERT GmbH</h2>
                </header>
                <div class="image-wrapper">
                    <div class="image featured"><img src="/referenzen/pzertWebPortal.png" alt="Webportal für die PZERT GmbH" i18n-alt /></div>
                </div>
                <p i18n>Für die PZERT GmbH wurde ein umfangreiches Webportal entwickelt, das die Interaktion
                    zwischen Kunden, Prüfern und Administratoren ermöglicht. Dieses Portal gestattet den
                    Austausch von Dateien und automatisiert den Versand von rollenbasierten
                    Benachrichtigungen, wodurch die Kommunikation per E-Mail und das mühsame Zuordnen
                    von Dokumenten zu Kunden und Projekten entfällt.</p>
                <p i18n>Das Portal erleichtert zudem die Terminplanung mit Kunden und fördert eine
                    effiziente Koordination innerhalb des Teams. Mit der Implementierung dieser
                    Plattform konnte die Kommunikationsstruktur der PZERT GmbH erheblich optimiert
                    werden.</p>
                <strong><u i18n>Kernfunktionalitäten und technische Details:</u></strong>
                <ul>
                    <li i18n><strong>Dateiaustausch:</strong> Ermöglicht den einfachen Upload und Download
                        von Dokumenten.</li>
                    <li i18n><strong>Rollenbasierte Benachrichtigungen:</strong> Automatische
                        Benachrichtigungen je nach Nutzerrolle zur Verbesserung der Kommunikation.</li>
                    <li i18n><strong>Terminplanung:</strong> Einsehen und Vereinbaren von Terminen direkt im
                        Portal.</li>
                    <li i18n><strong>Koordination:</strong> Vereinfacht die Zusammenarbeit und Koordination
                        zwischen allen Beteiligten.</li>
                </ul>
            </section>
            <section class="col-6 col-12-narrower feature text-start">
                <header class="major">
                    <h2 i18n>Progressive Web App (PWA) für die PZERT GmbH</h2>
                </header>
                <div class="image-wrapper">
                    <div class="image featured"><img src="/referenzen/reisekosten.png" alt="Progressive Web App (PWA) für die PZERT GmbH" i18n-alt /></div>
                </div>
                <p i18n>Entwicklung einer Progressive Web App (PWA) zur Verwaltung von Stammdaten und
                    papierlosen Verarbeitung von Reisekostenbelegen. Ziel war es, Prozesse zu
                    automatisieren, Effizienz zu steigern und die Bearbeitungszeit zu verkürzen.</p>

                <p i18n>Die App wurde mit dem <strong>Angular-Framework</strong> und <strong>Spring Boot
                        mit Java</strong> entwickelt, um eine robuste, skalierbare und
                    benutzerfreundliche Anwendung zu gewährleisten.</p>

                <p i18n>Die Anwendung ermöglicht es den Nutzern, Vorgänge auszuwählen, Kosten zu buchen
                    und Belege zu fotografieren. Durch die Nutzung der App entfällt die
                    Notwendigkeit, Belege manuell zu scannen und zuzuordnen, was den Prozess
                    beschleunigt.</p>

            </section>
        </div>
    </section>
</div>
<div class="wrapper">
    <section class="container">
        <div class="row features justify-content-center">
            <section class="col-6 col-12-narrower feature text-start">
                <header class="major">
                    <h2 i18n>Webseite Jagd­schule Wildbret­schütz</h2>
                </header>
                <div class="image-wrapper">
                    <a href="https://www.jagdschule-wildbretschuetz.de/home" target="_blank" rel="noopener noreferrer" class="image featured"
                        aria-label="Jagdschule Wildbretschuetz Webseite in neuem Tab öffnen" i18n-aria-label><img src="/referenzen/jagdschuleWildbretschuetz.png"
                            alt="Jagd­schule Wildbret­schütz in Hechingen" i18n-alt /></a>
                </div>
                <p i18n>Die Referenz der Jagdschule Wildbretschütz in Hechingen zeichnet sich
                    durch ihre technische Raffinesse aus. Diese Webseite wurde mithilfe des Spring Boot
                    Frameworks im Backend und des Angular Frameworks im Frontend entwickelt. Ein
                    besonderes Highlight ist die statische Codegenerierung mit einer speziellen
                    Optimierung für Google SEO, was die Website nicht nur technisch fortschrittlich,
                    sondern auch besonders suchmaschinenfreundlich macht.</p>
            </section>
            <section class="col-6 col-12-narrower feature text-start">
                <header class="major">
                    <h2 i18n>Integration der Lexware Office API</h2>
                </header>
                <div class="image-wrapper">
                    <div class="image featured"><a href="https://office.lexware.de/public-api/" class="image featured" aria-label="Lexware Office Public API Webseite öffnen" i18n-aria-label><img
                                src="/referenzen/grafik-func-public-api-002-lexoffice-rechnungsprogramm-buchhaltungssoftware-1129x0-c-center.png"
                                alt="Lexware Office Integration" i18n-alt /></a></div>
                </div>
                <p i18n>Die AlbCode GmbH hat erfolgreich die <a href="https://office.lexware.de/public-api/" target="_blank" rel="noopener noreferrer">Lexware Office API</a> bei
                    der PZERT GmbH implementiert, um
                    die Rechnungsstellung zu automatisieren. Vor der Integration war der
                    Prozess bei der PZERT GmbH zeitaufwendig und manuell, was zu Effizienzverlusten führte. Durch die Lösung von AlbCode werden Rechnungen nun automatisch erstellt
                    und bei
                    Bedarf direkt versendet, wodurch der administrative Aufwand erheblich reduziert wurde.</p>
                <p i18n><b>Ergebnis:</b> Die Automatisierung sorgt für schnellere, fehlerfreie Rechnungsprozesse und steigert die Effizienz sowie Kundenzufriedenheit bei der PZERT GmbH.
                    Diese
                    erfolgreiche Zusammenarbeit unterstreicht AlbCodes Kompetenz in der Optimierung digitaler Geschäftsprozesse.</p>
            </section>
        </div>
    </section>
</div>
<div class="wrapper pb-3">
    <section class="container">
        <div class="row features justify-content-center ">

            <section class="col-6 col-12-narrower feature text-start">
                <header class="major">
                    <h2 i18n>Microservice für todoist - Integration</h2>
                </header>
                <div class="image-wrapper">
                    <a href="https://todoist.com/" class="image featured" aria-label="Todoist Webseite öffnen" i18n-aria-label><img src="/logos/todoist.svg" alt="todoist" i18n-alt /></a>
                </div>
                <p i18n>Für das Projekt von Herrn Jürgen Eisele wurde ein spezialisierter Microservice
                    entwickelt, der auf der leistungsfähigen Spring Boot-Plattform basiert. Dieser
                    Service zeichnet sich durch seine Fähigkeit aus, Webhooks von <a style="color: rgb(43, 204, 204);" href="https://todoist.com/" target="_blank"
                        rel="noopener noreferrer">Todoist</a>
                    effizient zu
                    verarbeiten, um die Interaktion und Produktivität der Nutzer zu verbessern.</p>

                <strong><u i18n>Kernfunktionalitäten und technische Details:</u></strong><br><br>
                <ul>
                    <li i18n><strong>Webhook-Integration:</strong> Der Service ist konfiguriert, um auf
                        Webhooks von Todoist zu reagieren. Bei jedem ausgelösten Ereignis in Todoist –
                        wie dem Hinzufügen, Bearbeiten oder Löschen einer Aufgabe – wird ein Webhook an
                        den Service gesendet.</li>
                    <li i18n><strong>Ereignisbasierte Logik:</strong> Der Service analysiert den Typ des
                        Ereignisses, das von Todoist gesendet wird. Dafür wurde eine spezifische Logik
                        implementiert, die unterschiedliche Arten von Ereignissen erkennen und
                        entsprechend darauf reagieren kann.</li>
                    <li i18n><strong>Push-Benachrichtigungssystem:</strong> Basierend auf dem analysierten
                        Ereignistyp generiert der Microservice maßgeschneiderte Push-Nachrichten. Diese
                        Benachrichtigungen werden dann an eine Hintergrund-App gesendet, die speziell
                        für dieses Projekt entwickelt wurde.
                        <a style="color: rgb(43, 204, 204);" target="_blank" rel="noopener noreferrer"
                            href="https://developer.apple.com/documentation/usernotifications/setting_up_a_remote_notification_server/sending_notification_requests_to_apns"><i>Sending
                                notification requests to APNs</i></a>
                    </li>
                    <li i18n><strong>Echtzeit-Reaktionsfähigkeit:</strong> Der Service wurde für eine
                        schnelle Reaktionsfähigkeit optimiert, um sicherzustellen, dass die
                        Benachrichtigungen in Echtzeit versendet werden, sobald ein Ereignis in Todoist
                        auftritt.</li>
                    <li i18n><strong>Skalierbarkeit und Wartungsfreundlichkeit:</strong> Bei der Entwicklung
                        wurde besonderer Wert auf Skalierbarkeit und Wartungsfreundlichkeit gelegt, um
                        zukünftige Erweiterungen und Anpassungen zu erleichtern.</li>
                </ul>
                <p i18n>Durch die Implementierung dieses Microservices konnte eine effiziente und nahtlose
                    Integration mit Todoist erreicht werden, die den Nutzern ermöglicht, ihre Aufgaben
                    und Projekte effektiver zu verwalten. Die Kombination aus der leistungsfähigen
                    Spring Boot-Plattform und der maßgeschneiderten Entwicklung dieses Services stellt
                    eine bedeutende Verbesserung in der Verwaltung von Arbeitsabläufen und
                    Benachrichtigungssystemen dar.</p>
            </section>

            <section class="col-6 col-12-narrower feature text-start">
                <header class="major">
                    <h2 i18n>Referentenportal für das Bildungszentrum des Einzelhandels (BZE)</h2>
                </header>
                <div class="image-wrapper">
                    <a href="https://bze.de/" class="image featured"><img src="/referenzen/bze.png" alt="Bildungszentrum des Einzelhandels (BZE)" i18n-alt /></a>
                </div>
                <p i18n>Für das Bildungszentrum des Einzelhandels (BZE) haben wir ein webbasiertes Referentenportal entwickelt, das speziell auf die Anforderungen der internen
                    Seminarverwaltung zugeschnitten ist.</p>

                <strong><u i18n>Projektinhalte:</u></strong><br><br>
                <ul>
                    <li i18n>Benutzerverwaltung: Übernahme bestehender Referentenzugänge inklusive sicherem Passwort-Hashing.</li>

                    <li i18n>Dokumentenmanagement: Integration von Vorlagen für Referentenerklärungen und Verträge.</li>

                    <li i18n>Kalender- und Terminmanagement: Übersichtliche Monatsansichten mit Terminanzahl je Tag sowie detaillierte Tagesansichten inklusive Bestätigungs- und
                        Absagefunktion.</li>

                    <li i18n>Benutzerfreundlichkeit: Optimierte Darstellung für Desktop- und Mobilgeräte mit Fokus auf eine einfache und intuitive Bedienung.</li>
                </ul>

                <strong><u i18n>Besondere Anforderungen:</u></strong><br><br>
                <ul>
                    <li i18n>Sicherstellung der Datensicherheit durch Passwort-Hashing</li>

                    <li i18n>Flexible Darstellung komplexer Terminstrukturen</li>

                    <li i18n>Nahtlose Integration in die bestehende Systemlandschaft</li>
                </ul>

                <p i18n>Mit der Umsetzung dieses Portals konnten wir die Verwaltungsprozesse im Umgang mit externen Referenten für das BZE deutlich effizienter gestalten und die
                    Transparenz in der Seminarplanung nachhaltig verbessern.</p>
            </section>
        </div>
    </section>
</div>